import {
  capitalizeFirstLetterOfTitle,
  breedNameTextConverter,
} from "@/utils/converter"
import { REDIRECT_MAP } from "const"

const BUCKET = process.env.NEXT_PUBLIC_MEDIA_BUCKET

async function getRedirectPath(slug) {
  return REDIRECT_MAP[slug]
}

const getCoverImages = (category, breed, state) => {
  let coverImage = ""
  let mobileCoverImage = ""

  if (category) {
    coverImage = `/landing/category/cover/${category}.png`
    mobileCoverImage = `/landing/category/mobileCover/${category}.png`
  } else if (breed?.coverPicture?.small) {
    coverImage = `${BUCKET}${breed.coverPicture.small}`
    mobileCoverImage = `${BUCKET}${breed.mobileCoverPicture.small}`
  } else if (state?.coverPicture) {
    coverImage = `${BUCKET}${state.coverPicture.small}`
    mobileCoverImage = `${BUCKET}${state.mobileCoverPicture?.small}`
  } else {
    coverImage = "/landing/generic.webp"
    mobileCoverImage = "/landing/generic-mobile.webp"
  }

  return { coverImage, mobileCoverImage }
}

const getTitleAndDescription = (
  landingType,
  breed,
  category,
  variables,
  city
) => {
  let title = ""
  let description = ""

  switch (landingType) {
    case "breed":
      title = `${breedNameTextConverter(breed?.name)} Puppies for Sale`
      description = `Explore adorable ${breedNameTextConverter(breed?.name)} puppies from our network of 1,000+ caring breeders.`
      break

    case "category":
      title = `${category.includes("Affordable") ? capitalizeFirstLetterOfTitle(category) : `${capitalizeFirstLetterOfTitle(category)} for Sale`}`
      description = `Explore adorable ${category} from our network of 1,000+ caring breeders.`
      break
    // /puppies-for-sale/[state]
    case "state":
      title = `Puppies for Sale in ${variables?.stateName} `
      description = `Explore adorable puppies in ${variables?.stateName} from our network of 1,000+ caring breeders.`
      break
    // /puppies-for-sale/[breed]/[state]
    case "breedState":
      title = `${breedNameTextConverter(breed?.name)} Puppies for Sale in ${variables?.stateName}`
      description = `Explore adorable ${breedNameTextConverter(breed?.name)}s in ${variables?.stateName} from our network of 1,000+ caring breeders.`
      break
    // /puppies-for-sale/[breed]/[state]/[city]
    case "breedCity":
      title = `${breedNameTextConverter(breed?.name)} Puppies for Sale Near ${city}, ${variables.state}`
      description = `Explore adorable ${breedNameTextConverter(breed?.name)}s in ${city}, ${variables.state} from our network of 1,000+ caring breeders.`
      break
    // /puppies-for-sale/[state]/[city]
    case "stateCity":
      title = `Puppies for Sale Near ${city}, ${variables.state}`
      description = `Explore adorable puppies in ${city}, ${variables.state} from our network of 1,000+ caring breeders.`
      break
    default:
      description =
        "Explore adorable puppies from our network of 1,000+ caring breeders."
      break
  }

  return { title, description }
}

const hasBreedAndStateQuery = (router) =>
  Object.entries(router.query).length >= 2

export {
  getCoverImages,
  getTitleAndDescription,
  hasBreedAndStateQuery,
  getRedirectPath,
}
